import React, {useContext, useState, useEffect} from "react";

import {Form, Select, Input, Typography} from "antd";
import {Auth} from "@digatex/digatex-ui-lib";

import api from "../../../api";
import {properties} from "../../../properties";
import {ModalWindow} from "./ModalWindow";
import {CurrentUserContext} from "../../../contexts/AuthContext";

export function UnzipScopeModal({isModalVisible, setIsModalVisible, scope, onFinish, spin, setLoading}) {
    const close = () => setIsModalVisible(false);
	const [form] = Form.useForm();

    const user = useContext(CurrentUserContext);

	const handleCancel = () => {
		closeModal();
	};

	form.setFieldsValue({
        scope_name: scope?.name || "",
        scope_dsc: scope?.description || "",
        unzip_by: user.email(),
    });

	return (
		<ModalWindow
			width={900}
			title={`Unzip Scope`}
			isModalVisible={isModalVisible}
			scrollVisible={false}
			onCancel={close}
			modalProps={{
				okText: "Submit",
				cancelText: "Cancel",
				okButtonProps: {form: "scopeUnzipForm", key: "submit", htmlType: "submit"},
			}}>
			<Form onFinish={(values) => onFinish(values, scope?._id)}
			        form={form} id="scopeUnzipForm"
			>
				<Form.Item label=<b>Scope Name</b> name="scope_name">
				      <Typography.Text><b> {form.getFieldValue("scope_name")} </b></Typography.Text>
				</Form.Item>
				<Form.Item label=<b>Scope Description</b> name="scope_dsc">
				    <Typography.Text><b> {form.getFieldValue("scope_dsc")} </b></Typography.Text>
				</Form.Item>
				<Form.Item label=<b>Unzip by</b> name="unzip_by">
				    <Typography.Text><b> {form.getFieldValue("unzip_by")} </b></Typography.Text>
				</Form.Item>
			</Form>
		</ModalWindow>
	);
}
